module.exports = __webpack_public_path__ + "static/media/Vinesh.273f8ab2.jpg";